import idsTokensDefault from '../../utils/tokens/idsTokens';

export const classes = (idsTokens = idsTokensDefault) => ({
  root: {
    borderColor: idsTokens.divider.default.color.medium,
    '.MuiList-root > &': {
      minWidth: idsTokens.listItem.default.spacing.small.min.width,
      paddingTop: idsTokens.listItem.default.spacing.small.padding.top,
      paddingBottom: idsTokens.listItem.default.spacing.small.padding.bottom,
    },
  },
});
